import type { Post } from '../types/post';
import { useSearchQuery } from './use-search-query';

const normalize = (text: string) => text.toLowerCase().replaceAll(' ', '');

const matchesQuery = (post: Post, normalizedQuery: string) => {
  const normalizedTitle = normalize(post.metadata.title);
  const normalizedDescription = normalize(post.metadata.description);

  return (
    normalizedTitle.includes(normalizedQuery) ||
    normalizedDescription.includes(normalizedQuery)
  );
};

const searchPosts = (posts: Post[], query: string | null) => {
  if (!query) return posts;

  const normalizedQuery = normalize(query);
  return posts.filter((post) => matchesQuery(post, normalizedQuery));
};

export function useFilteredPosts(posts: Post[]) {
  const { query } = useSearchQuery();
  return searchPosts(posts, query);
}
